import Swiper, { EffectFade } from 'swiper';
Swiper.use([EffectFade])

export default function CoverSlider () {
    const COVER = document.querySelector('.mtt-cover')
    if (COVER) {
        const slider = new Slider(COVER)
        slider.init()
    }
}

class Slider {
    constructor (wrapper) {
        this.wrapper = wrapper
        this.slider = this.wrapper.querySelector('.mtt-cover__slides')
        this.slides = this.wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
        this.progressBar = this.wrapper.querySelector('.progress')
        this.autoplay = 8000

        this.init = () => {
            this.initSlider()
        }
    }

    initSlider () {
        this.swiper = new Swiper (this.slider, {
            preloadImages: false,
            lazy: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            speed: 1000,
            watchSlidesVisibility: true,
        });

        this.addEventListeners()

        if (this.slides.length > 1) {
            this.addProgressBar()
        }
    }

    addEventListeners(){
        const PAGINATION_ITEMS = this.wrapper.querySelectorAll('.mtt-cover__swiper-pagination--item')

        if (PAGINATION_ITEMS.length) {
            for (let i = 0; i < PAGINATION_ITEMS.length; i++) {
                const PAGINATION_ITEM = PAGINATION_ITEMS[i]

                PAGINATION_ITEM.addEventListener('click', () => {
                    this.changeSlide(PAGINATION_ITEM.getAttribute('data-id'))
                })
            }
        }
    }

    addProgressBar () {
        if (this.autoplay) {
            this.progressBar.style.animationDuration = this.autoplay + 'ms'
        }

        this.progressBar.addEventListener('animationend', () => {
            this.onAnimationEnd()
        })

        this.resetOnChange()
    }

    onAnimationEnd () {
        this.changeSlide()
    }

    changeSlide (slide = 0) {
        if(this.slider.querySelector('.swiper-slide-active .video-mp4')){
            this.slider.querySelector('.swiper-slide-active .video-mp4').pause()
            this.slider.querySelector('.swiper-slide-active .video-mp4').classList.add('hide-video')
        }
        if(slide !== 0){
            this.swiper.slideTo(slide)
        }else {
            this.swiper.slideNext()
        }
        if(this.slider.querySelector('.swiper-slide-active .video-mp4')){
            this.slider.querySelector('.swiper-slide-active .video-mp4').play()
            this.slider.querySelector('.swiper-slide-active .video-mp4').classList.remove('hide-video')
        }
        this.progressBar.style.animation = 'none'
        void this.progressBar.offsetHeight // Triggers Reflow
        this.progressBar.style.animation = null
        this.progressBar.style.animationDuration = this.autoplay + 'ms'
        this.setActivePagination()
    }

    setActivePagination(){
        const SLIDES = this.wrapper.querySelectorAll('.mtt-cover__swiper-pagination--item').length
        let active_index = this.swiper.activeIndex
        if(active_index > SLIDES) {
            active_index = 1
        }
        const CUR_ACTIVE_ITEM = this.wrapper.querySelector('.mtt-cover__swiper-pagination--item.active')
        const NEXT_ACTIVE_ITEM = this.wrapper.querySelector('.mtt-cover__swiper-pagination--item[data-id="'+active_index+'"]')

        if(CUR_ACTIVE_ITEM){
            CUR_ACTIVE_ITEM.classList.remove('active')
        }
        if(NEXT_ACTIVE_ITEM){
            NEXT_ACTIVE_ITEM.classList.add('active')
        }
    }

    resetOnChange () {
        this.swiper.on('slideChange', () => {
            this.progressBar.style.animation = 'none'
            void this.progressBar.offsetHeight // Triggers Reflow
            this.progressBar.style.animation = null
            this.progressBar.style.animationPlayState = 'paused' // Optional
            this.progressBar.style.animationDuration = this.autoplay + 'ms'
        })
    }
}
